import { useEffect, useState } from "react";

const DEFAULT_INTERVAL_MS = 2000;

/**
 * While `active` is true, advances once per `intervalMs` and returns the
 * current entry of `messages` (cycling back to the start). When `active` is
 * false it returns the first message and resets the cycle, so the next
 * activation starts from the beginning.
 *
 * Used for a rotating "we're working on it" carousel inside a button during a
 * slow request (e.g. preparing carrier quotes): it improves the perceived
 * wait and, alongside the submit guard, further discourages rage clicks.
 *
 * `messages` is read during render (not inside the effect), so callers may
 * pass an inline array without restarting the timer on every render.
 */
export function useBookShipmentRotatingMessage(
  messages: Array<string>,
  active: boolean,
  intervalMs: number = DEFAULT_INTERVAL_MS,
): string {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!active) {
      setTick(0);
      return;
    }

    const timer = setInterval(() => {
      setTick((previous) => previous + 1);
    }, intervalMs);

    return () => clearInterval(timer);
  }, [active, intervalMs]);

  return messages[tick % messages.length] ?? messages[0] ?? "";
}
